import React, {useState, useEffect, useCallback} from 'react'
import './../../App.css';
import './Reports.css';
import axios from 'axios';
import { CreateSearchBarWithPlaceHolder } from '../CommonObjects';
import {CreateTableForEmployeeSelect} from '../ManageTable';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import jsPDF from "jspdf";
import { format } from 'date-fns';
//icons
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function Payslip({isHideSideMenu}) {
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payrollPeriodDescription, setPayrollPeriodDescription] = useState("");
    const [company, setCompany] = useState("");
    const [classificationId, setClassificationId] = useState(0);
    const [departmentId, setDepartmentId] = useState(0);
    const [locationId, setLocationId] = useState(0);

    // const [employeeInfo, setEmployeeInfo] = useState([]);

    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const [errorState, setErrorState] = useState(false);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const formatName = (name) => {
        if(name){
            const nameParts = name.split(", ");
            const formattedName = nameParts.map(part => {
                return part.split('-').map(subPart => 
                    subPart.charAt(0).toUpperCase() + subPart.slice(1).toLowerCase()
                ).join('-');
            }).join(", ");

            return formattedName.replace(/\b\w/g, (match) => match.toUpperCase());
        }
        return "";
    };

    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    }

    const downloadPDF = useCallback (async (payrolls) => {
        // Create a new jsPDF instance
        const _doc = new jsPDF();

        const drawLine = (doc, lineY) => {
            // Get the total width of the page
            const pageWidth = doc.internal.pageSize.getWidth();
            
            // Define the padding
            const padding = 10;
        
            // Calculate the start and end points of the line
            const startX = padding;
            const endX = pageWidth - padding;
            const startY = lineY;
        
            // Draw the line
            doc.line(startX, startY, endX, startY);
        };
        const title = (doc, title, titleX, titleY) =>{
            doc.setFont("helvetica", "bold");
            doc.setFontSize(11);
            // doc.setTextColor("#668fca");
            doc.setLineWidth(0.5);
            doc.text(title, titleX, titleY);
        }
        const subTitle = (doc, text, x, y, options = {}) => {
            const { fontSize = 12, color = "#000000", thickness = 0.5, lineHeightRatio = 0.1 } = options;
        
            doc.setFont("helvetica", "bold");
            doc.setFontSize(fontSize);
            doc.setTextColor(color);
            doc.text(text, x, y);
        
            const textWidth = doc.getTextWidth(text);
            const underlineY = y + (fontSize * lineHeightRatio);
        
            doc.setLineWidth(thickness);
            doc.line(x, underlineY, x + textWidth, underlineY);
        };
        const infoWithValue8 = (doc, label, labelX, labelY, value, valueX, valueY, maxWidth) =>{
            doc.setFont("helvetica", "bold");
            doc.setFontSize(8);
            // doc.setTextColor("#668fca");
            doc.text(label, labelX, labelY); 
            doc.setFont("helvetica", "normal");
            // doc.setTextColor("#686868");
            const splitText = doc.splitTextToSize(value, maxWidth); // Split the text into lines based on maxWidth
            doc.text(splitText, valueX, valueY);
        }
        const infoWithValue = (doc, label, labelX, labelY, value, valueX, valueY, maxWidth) =>{
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            // doc.setTextColor("#668fca");
            doc.text(label, labelX, labelY); 
            doc.setFont("helvetica", "normal");
            // doc.setTextColor("#686868");
            const splitText = doc.splitTextToSize(value, maxWidth); // Split the text into lines based on maxWidth
            doc.text(splitText, valueX, valueY);
        }
        const decimalConverter = (value) =>{
            if(!value){
                return (0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
            return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
        function formatDate(dateStr) {
            const date = new Date(dateStr);
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            const formattedDate = date.toLocaleDateString("en-US", options);
            return formattedDate;
        }

        payrolls.forEach((payroll, index) => {
            if (index > 0) _doc.addPage();

            const otherCashAdvance = payroll.otherCashAdvances;
            const otherDeductions = payroll.companyLoans;

            const halfPageWidth = _doc.internal.pageSize.getWidth() / 2;
            const secondInfoX = halfPageWidth + 5;
            
            // Add the image to the PDF
            if(company?.logo){
                const imgData = `data:image/png;base64,${company.logo}`;
                _doc.addImage(imgData, 'PNG', 65, 5, 70, 30);
            }

            title(_doc, `Payslip for Payroll: ${payrollPeriodDescription} `, 62.5, 35);
            drawLine(_doc, 42.5);

            infoWithValue(_doc, "Employee Name: ", 10, 50, payroll.employeePersonalInformationFullName? formatName(payroll.employeePersonalInformationFullName) : "", 50, 50);
            infoWithValue(_doc, "Employee Id: ", 10, 55, payroll.employeePersonalInformationEmployeeId ? payroll.employeePersonalInformationEmployeeId : "", 50, 55);
            infoWithValue(_doc, "Position: ", 10, 60, payroll.positionDescription ? payroll.positionDescription : "", 50, 60);
            infoWithValue(_doc, "Hired Date: ", 10, 65, payroll.dateEmployed ? formatDate(payroll.dateEmployed) : "", 50, 65);
            infoWithValue(_doc, "Employer: ", secondInfoX, 50, company.name ? company.name : "", secondInfoX + 50, 50);
            infoWithValue(_doc, "Classification: ", secondInfoX, 55, payroll.classificationDescription ? payroll.classificationDescription : "", secondInfoX + 50, 55);
            infoWithValue(_doc, "Location: ", secondInfoX, 60, payroll.locationDescription ? payroll.locationDescription : "", secondInfoX + 50, 60);
            infoWithValue(_doc, "Pay Type: ", secondInfoX, 65, payroll.payTypeDescription ? payroll.payTypeDescription : "", secondInfoX + 50, 65);
            drawLine(_doc, 70);

            const allowance = payroll.totalAllowance ?? 0;
            const benefits = payroll.totalBenefits ?? 0;
            const otherAddition = payroll.TotalAddition ?? 0;
            const otherAdjustment = payroll.TotalAdjustment ?? 0;

            const hoursNightDiff = payroll.totalNighDiff;
            const hoursRegularOT = payroll.totalHoursOTRegular;
            const hoursRestdayOT = payroll.totalHoursOTRestday;
            const hoursRegularHoliday = payroll.totalHoursOTHolidayRegular;
            const hoursSpecialHoliday = payroll.totalHoursOTHolidaySpecial;
            const hoursRestdayRegular = payroll.totalHoursOTRestdayHolidayRegular;
            const hoursRestdaySpecial = payroll.totalHoursOTRestdayHolidaySpecial;

            const totalDaysLeave = payroll.totalDaysLeaves * 8;
            const totalLeaves = payroll.totalLeaves ;

            const amountNightDiff = payroll.totalNighDiffAmount ?? 0;
            const amountRegularOT = payroll.totalOTRegular ?? 0;
            const amountRestdayOT = payroll.totalOTRestday ?? 0;
            const amountRegularHoliday = payroll.totalOTHolidayRegular ?? 0;
            const amountSpecialHoliday = payroll.totalOTHolidaySpecial ?? 0;
            const amountRestdayRegular = payroll.totalOTRestdayHolidayRegular ?? 0;
            const amountRestdaySpecial = payroll.totalOTRestdayHolidaySpecial ?? 0;

            const totalAdditionsOverAll = 
                allowance
                + benefits
                + otherAddition
                + otherAdjustment
                + amountNightDiff
                + amountRegularOT
                + amountRestdayOT
                + amountRegularHoliday
                + amountSpecialHoliday
                + amountRestdayRegular
                + amountRestdaySpecial;

            const absentDays = payroll.totalDaysAbsents;
            const absent = payroll.totalAbsents ?? 0;
            const otherDeduction = payroll.totalDeduction ?? 0;

            // const hoursTotalLate = payroll.totalHoursLate;
            const hoursTotalLate = payroll.lateValue;
            // const hoursTotalUndertime = payroll.totalHoursUndertime;
            const hoursTotalUndertime = payroll.undertimeValue;

            const amountTotalLate = payroll.totalLate ?? 0;
            const amountTotalUndertime = payroll.totalUndertime ?? 0;
            const amountTax = payroll.totalTax ?? 0;

            const totalDeductionOverAll = 
                absent
                + otherDeduction
                + amountTotalLate
                + amountTotalUndertime
                + amountTax;

            const balanceSSSLoan = payroll.totalSSSLoan;
            const balanceSSSCalamityLoan = payroll.totalSSSCalamityLoan;
            const balancePagibigLoan = payroll.totalPagibigLoan;
            const balancePagibigCalamityLoan = payroll.totalPagibigCalamityLoan;

            const deductionSSSLoan = payroll.totalSSSLoan ?? 0;
            const deductionSSSCalamityLoan = payroll.totalSSSCalamityLoan ?? 0;
            const deductionPagibigLoan = payroll.totalPagibigLoan ?? 0;
            const deductionPagibigCalamityLoan = payroll.totalPagibigCalamityLoan ?? 0;

            const totalLoansOverAll = deductionSSSLoan + deductionSSSCalamityLoan + deductionPagibigLoan + deductionPagibigCalamityLoan

            const sss = payroll.totalSSS ?? 0;
            const philhealth = payroll.totalPhilhealth ?? 0;
            const pagibig = payroll.totalPagibig ?? 0;

            const totalPremiumsOverAll = sss + philhealth + pagibig;

            const dailyRate = payroll.rate ?? 0;
            const daysWorked = payroll.totalDays ?? 0;
            const totalDaysPay = dailyRate * daysWorked;
            const basicPay = payroll.totalBasic ?? 0;
            const grossPay = payroll.totalGrossPay ?? 0;
            const netPay = payroll.totalNetPay ?? 0;

            subTitle(_doc, "ADDITIONS", 10, 80, { fontSize: 9, thickness: 0.5 });
            subTitle(_doc, "Hours", 50, 80, { fontSize: 9, thickness: 0.5 });
            subTitle(_doc, "Amount", 75, 80, { fontSize: 9, thickness: 0.5 });
            infoWithValue(_doc, "Allowance: ", 10, 85, "", 40, 85);
            infoWithValue(_doc, "", 10, 85, "-", 50, 85);
            infoWithValue(_doc, "", 10, 85, decimalConverter(allowance), 75, 85);
            infoWithValue(_doc, "Benefits: ", 10, 90, "", 40, 90);
            infoWithValue(_doc, "", 10, 90, "-", 50, 90);
            infoWithValue(_doc, "", 10, 90, decimalConverter(benefits), 75, 90);
            infoWithValue(_doc, "Other Addition: ", 10, 95, "", 40, 95);
            infoWithValue(_doc, "", 10, 95, "-", 50, 95);
            infoWithValue(_doc, "", 10, 95, decimalConverter(otherAddition), 75, 95);
            infoWithValue(_doc, "Other Adjustment: ", 10, 100, "", 40, 100);
            infoWithValue(_doc, "", 10, 100, "-", 50, 100);
            infoWithValue(_doc, "", 10, 100, decimalConverter(otherAdjustment), 75, 100);
            infoWithValue(_doc, "Night Differential: ", 10, 105, "", 40, 105);
            infoWithValue(_doc, "", 10, 105, decimalConverter(hoursNightDiff), 50, 105);
            infoWithValue(_doc, "", 10, 105, decimalConverter(amountNightDiff), 75, 105);
            infoWithValue(_doc, "Regular OT: ", 10, 110, "", 40, 110);
            infoWithValue(_doc, "", 10, 110, decimalConverter(hoursRegularOT), 50, 110);
            infoWithValue(_doc, "", 10, 110, decimalConverter(amountRegularOT), 75, 110);
            infoWithValue(_doc, "Restday OT: ", 10, 115, "", 40, 115);
            infoWithValue(_doc, "", 10, 115, decimalConverter(hoursRestdayOT), 50, 115);
            infoWithValue(_doc, "", 10, 115, decimalConverter(amountRestdayOT), 75, 115);
            infoWithValue(_doc, "Regular Holiday: ", 10, 120, "", 40, 120);
            infoWithValue(_doc, "", 10, 120, decimalConverter(hoursRegularHoliday), 50, 120);
            infoWithValue(_doc, "", 10, 120, decimalConverter(amountRegularHoliday), 75, 120);
            infoWithValue(_doc, "Special Holiday: ", 10, 125, "", 40, 125);
            infoWithValue(_doc, "", 10, 125, decimalConverter(hoursSpecialHoliday), 50, 125);
            infoWithValue(_doc, "", 10, 125, decimalConverter(amountSpecialHoliday), 75, 125);
            infoWithValue(_doc, "Restday Regular: ", 10, 130, "", 40, 130);
            infoWithValue(_doc, "", 10, 130, decimalConverter(hoursRestdayRegular), 50, 130);
            infoWithValue(_doc, "", 10, 130, decimalConverter(amountRestdayRegular), 75, 130);
            infoWithValue(_doc, "Restday Special: ", 10, 135, "", 40, 135);
            infoWithValue(_doc, "", 10, 135, decimalConverter(hoursRestdaySpecial), 50, 135);
            infoWithValue(_doc, "", 10, 135, decimalConverter(amountRestdaySpecial), 75, 135);
            infoWithValue(_doc, "Leaves: ", 10, 139, "", 40, 139);
            infoWithValue(_doc, "", 10, 139, decimalConverter(totalDaysLeave), 50, 139);
            infoWithValue(_doc, "", 10, 139, decimalConverter(totalLeaves), 75, 139);
            infoWithValue(_doc, "Total Additions ", 10, 142.5, "", 40, 142.5);
            infoWithValue(_doc, "", 10, 142.5, decimalConverter(totalAdditionsOverAll), 75, 142.5);

            subTitle(_doc, "DEDUCTIONS", secondInfoX, 80, { fontSize: 9, thickness: 0.5 });
            subTitle(_doc, "Hours", secondInfoX + 40, 80, { fontSize: 9, thickness: 0.5 });
            subTitle(_doc, "Amount", secondInfoX + 70, 80, { fontSize: 9, thickness: 0.5 });
            infoWithValue(_doc, "Absent: ", secondInfoX, 85, "", secondInfoX + 40, 85);
            infoWithValue(_doc, "", secondInfoX, 85, `${decimalConverter(absentDays)} days`, secondInfoX + 40, 85);
            infoWithValue(_doc, "", secondInfoX, 85, decimalConverter(absent), secondInfoX + 70, 85);
            infoWithValue(_doc, "Late: ", secondInfoX, 90, "", secondInfoX + 40, 90);
            infoWithValue8(_doc, "", secondInfoX, 90, hoursTotalLate, secondInfoX + 40, 90);
            infoWithValue(_doc, "", secondInfoX, 90, decimalConverter(amountTotalLate), secondInfoX + 70, 90);
            infoWithValue(_doc, "Undertime: ", secondInfoX, 95, "", secondInfoX + 40, 95);
            infoWithValue8(_doc, "", secondInfoX, 95, hoursTotalUndertime, secondInfoX + 40, 95);
            infoWithValue(_doc, "", secondInfoX, 95, decimalConverter(amountTotalUndertime), secondInfoX + 70, 95);
            infoWithValue(_doc, "Other Deduction: ", secondInfoX, 100, "", secondInfoX + 40, 100);
            infoWithValue(_doc, "", secondInfoX, 100, "-", secondInfoX + 40, 100);
            infoWithValue(_doc, "", secondInfoX, 100, decimalConverter(otherDeduction), secondInfoX + 70, 100);
            infoWithValue(_doc, "Tax: ", secondInfoX, 105, "", secondInfoX + 40, 105);
            infoWithValue(_doc, "", secondInfoX, 105, "-", secondInfoX + 40, 105);
            infoWithValue(_doc, "", secondInfoX, 105, decimalConverter(amountTax), secondInfoX + 70, 105);
            infoWithValue(_doc, "Total Deductions: ", secondInfoX, 112.5, "", secondInfoX + 40, 112.5);
            infoWithValue(_doc, "", secondInfoX, 112.5, decimalConverter(totalDeductionOverAll), secondInfoX + 70, 112.5);

            drawLine(_doc, 147.5);

            subTitle(_doc, "PREMIUMS", 10, 155, { fontSize: 9, thickness: 0.5 });
            infoWithValue(_doc, "SSS: ", 10, 160, decimalConverter(sss), 50, 160);
            infoWithValue(_doc, "Philhealth: ", 10, 165, decimalConverter(philhealth), 50, 165);
            infoWithValue(_doc, "Pagibig: ", 10, 170, decimalConverter(pagibig), 50, 170);
            infoWithValue(_doc, "Total Premiums: ", 10, 177.5, decimalConverter(totalPremiumsOverAll), 50, 177.5);


            subTitle(_doc, "LOANS", secondInfoX, 155, { fontSize: 9, thickness: 0.5 });
            subTitle(_doc, "Balance", secondInfoX + 40, 155, { fontSize: 9, thickness: 0.5 });
            subTitle(_doc, "Deduction", secondInfoX + 70, 155, { fontSize: 9, thickness: 0.5 });
            infoWithValue(_doc, "SSS Loan: ", secondInfoX, 160, "", secondInfoX + 50, 160);
            infoWithValue(_doc, "", secondInfoX, 160, decimalConverter(balanceSSSLoan), secondInfoX + 40, 160);
            infoWithValue(_doc, "", secondInfoX, 160, decimalConverter(deductionSSSLoan), secondInfoX + 70, 160);
            infoWithValue(_doc, "SSS Calamity Loan: ", secondInfoX, 165, "", secondInfoX + 50, 165);
            infoWithValue(_doc, "", secondInfoX, 165, decimalConverter(balanceSSSCalamityLoan), secondInfoX + 40, 165);
            infoWithValue(_doc, "", secondInfoX, 165, decimalConverter(deductionSSSCalamityLoan), secondInfoX + 70, 165);
            infoWithValue(_doc, "Pagibig Loan: ", secondInfoX, 170,"", secondInfoX + 50, 170);
            infoWithValue(_doc, "", secondInfoX, 170, decimalConverter(balancePagibigLoan), secondInfoX + 40, 170);
            infoWithValue(_doc, "", secondInfoX, 170, decimalConverter(deductionPagibigLoan), secondInfoX + 70, 170);
            infoWithValue(_doc, "Pagibig Calamity Loan: ", secondInfoX, 175, "", secondInfoX + 50, 175);
            infoWithValue(_doc, "", secondInfoX, 175, decimalConverter(balancePagibigCalamityLoan), secondInfoX + 40, 175);
            infoWithValue(_doc, "", secondInfoX, 175, decimalConverter(deductionPagibigCalamityLoan), secondInfoX + 70, 175);
            infoWithValue(_doc, "Total Loans: ", secondInfoX, 182.5, "", secondInfoX + 50, 182.5);
            infoWithValue(_doc, "", secondInfoX, 182.5, decimalConverter(totalLoansOverAll), secondInfoX + 70, 182.5);
            drawLine(_doc, 190);

            subTitle(_doc, "SUMMARY", secondInfoX, 200, { fontSize: 9, thickness: 0.5 });
            infoWithValue(_doc, "Basic Pay: ", secondInfoX, 210, decimalConverter(basicPay), secondInfoX + 40, 210);
            infoWithValue(_doc, "Daily Rate: ", secondInfoX, 215, decimalConverter(dailyRate), secondInfoX + 40, 215);
            infoWithValue(_doc, "Days Worked: ", secondInfoX, 220, decimalConverter(daysWorked), secondInfoX + 40, 220);
            infoWithValue(_doc, "Total Days Pay: ", secondInfoX, 225, decimalConverter(totalDaysPay), secondInfoX + 40, 225);
            infoWithValue(_doc, "Gross Pay: ", secondInfoX, 230, decimalConverter(grossPay), secondInfoX + 40, 230);
            infoWithValue(_doc, "Net Pay: ", secondInfoX, 237.5, decimalConverter(netPay), secondInfoX + 40, 237.5);

            subTitle(_doc, "ADVANCES (Other Loans)", 10, 200, { fontSize: 9, thickness: 0.5 });

            let cashAdvanceY = 205;

            otherCashAdvance.forEach(data => {
                infoWithValue(_doc, `${data.description ? data.description : "No description" }: `, 10, cashAdvanceY, decimalConverter(data.defaultDeduction), 50, cashAdvanceY);

                cashAdvanceY += 5;
            });

            let companyLoanY = cashAdvanceY + 5;
            
            subTitle(_doc, "ADVANCES (Other Company Loans)", 10, companyLoanY, { fontSize: 9, thickness: 0.5 });

            otherDeductions.forEach(data => {
                infoWithValue(_doc, `${data.description ? data.description : "No description" }: `, 10, companyLoanY + 5, decimalConverter(data.defaultDeduction), 50, companyLoanY + 5);

                companyLoanY += 5;
            });

            drawLine(_doc, companyLoanY + 40);

            title(_doc, `NOTHING FOLLOWS`, secondInfoX - 30, companyLoanY + 55);
        });

        // Save the PDF
        _doc.save(`Payslip_${payrollPeriodDescription}.pdf`);
    }, [company, payrollPeriodDescription]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Reports/payslip/payrollperiod/${payrollPeriodId}/classification/${classificationId}/department/${departmentId}/location/${locationId}`;

        try {
            setLoadingRequest(true);
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            if(response.data.length <= 0){
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage("No record found.");
                return;
            }
            
            downloadPDF(response.data);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false); // Set loading state to false after data fetching is complete
        }
    }, [downloadPDF, payrollPeriodId, classificationId, departmentId, locationId]);

    const fetchDataProcess = useCallback(async () => {
        const apiUrl =  domain + `/api/Reports/process-payslip/payrollperiod/${payrollPeriodId}/classification/${classificationId}/department/${departmentId}/location/${locationId}`;

        try {
            setLoadingRequest(true);
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            if(response.data.length <= 0){
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage("No record found.");
                return;
            }
            
            downloadPDF(response.data);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false); // Set loading state to false after data fetching is complete
        }
    }, [downloadPDF, payrollPeriodId, classificationId, departmentId, locationId]);

    const generate = async () =>{
        /* if(!employeePersonalInformationId
            && !payrollPeriodId
            && !company
        ){
            setErrorState(true);
            return;
        } */
        if(!payrollPeriodId
            || !company
        ){
            setErrorState(true);
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Fill up all fields");
            return;
        }
        
        await fetchData();
        setErrorState(false);
    };

    const checkProcess = async () =>{
        /* if(!employeePersonalInformationId
            && !payrollPeriodId
            && !company
        ){
            setErrorState(true);
            return;
        } */
        if(!payrollPeriodId
            || !company
        ){
            setErrorState(true);
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Fill up all fields");
            return;
        }
        
        await fetchDataProcess();
        setErrorState(false);
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo shadow-xl">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Payslip"}</span>
                            </div>
                            <h3>Generate Payslip</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row" style={{alignItems: "center", justifyContent: "normal"}}>
                                <div className="info-item3 info-item column" style={{display: "none"}}>
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Employee</div>
                                    <div className="info-item-input">
                                        <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Employee"
                                                value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                            />
                                            <button className="select row"
                                                    onClick={()=>setShowEmployeeForm(true)}
                                            ><SearchIcon/></button>
                                        </div>
                                        <span style={{
                                                visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                        </span>
                                        {/* {EmployeeIdSelect(employeePersonalInformationId, setEmployeePersonalInformationId)} */}
                                    </div>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Payroll Period</div>
                                    <div className="info-item-input">
                                        <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} setPayrollPeriodDescription={setPayrollPeriodDescription}/>
                                    </div>
                                    <span style={{
                                                visibility: !payrollPeriodId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Company</div>
                                    <div className="info-item-input">
                                        <CompanyTypeSelect company={company} setCompany={setCompany}/>
                                    </div>
                                    <span style={{
                                                visibility: !company && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Classification</div>
                                    <div className="info-item-input">
                                        <ClassificationIdSelect classificationId={classificationId} setClassificationId={setClassificationId}/>
                                    </div>
                                    <span style={{
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="info-item-holder row" style={{justifyContent: "normal"}}>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Department</div>
                                    <div className="info-item-input">
                                        <DepartmentIdSelect departmentId={departmentId} setDepartmentId={setDepartmentId}/>
                                    </div>
                                    <span style={{
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Location</div>
                                    <div className="info-item-input">
                                        <LocationIdSelect locationId={locationId} setLocationId={setLocationId}/>
                                    </div>
                                    <span style={{
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row gap-2" style={{justifyContent:"start"}}>
                                <button id="sssReportGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                                <button id="sssReportGenerate"
                                    className="text-white bg-orange-400 hover:bg-orange-500 row cursor-pointer" 
                                    onClick={checkProcess}
                                    > CHECK PROCESS
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
                    // setEmployeeInfo={setEmployeeInfo}
            >
            </EmployeeSelectForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "10000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee,
    setEmployeeInfo
}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        setEmployeeInfo(selectedEmployee);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function PayrollPeriodIdSelect({payrollPeriodId, setPayrollPeriodId, setPayrollPeriodDescription}){
    const [isSelected, setIsSelected] = useState(false);
    const [data, setData] = useState([]);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayrollPeriodId(event.target.value);
        const selectedPayroll = data.find(item => (item.id).toString() ===  event.target.value);
        setPayrollPeriodDescription(selectedPayroll.name)
    };

    const fetchData = async () => {
        //const currentYear = new Date().getFullYear();
        //const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
        const apiUrl =  domain + `/api/PayrollPeriod/active`; // changed

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(payrollPeriodId !== "" && payrollPeriodId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payrollPeriodId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payrollPeriodId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose payroll period</option>
            {data.map((payrollPeriodId) => ( 
                SetPayrollPeriodId(payrollPeriodId)
            ))}
            </select>
        </div>
    );
};
function SetPayrollPeriodId(payrollPeriodId){
    const formattedDateFrom = format(payrollPeriodId.dateFrom, 'MM/dd/yyyy');
    const formattedDateTo = format(payrollPeriodId.dateTo, 'MM/dd/yyyy');

    return(
        <option value={payrollPeriodId.id}>{`${formattedDateFrom} - ${formattedDateTo} ${payrollPeriodId.payTypeDescription ? payrollPeriodId.payTypeDescription : ""}`}
        </option>
    )
}
function CompanyTypeSelect({company, setCompany}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const selectedCompanyId = event.target.value; // Get the selected company ID
        const selectedCompany = data.find((comp) => comp.id.toString() === selectedCompanyId.toString()); // Find the full company object

        if (selectedCompany) {
            setCompany(selectedCompany); // Set the full company object
            setIsSelected(true);
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Company/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if (company !== "" && company !== 0 && company !== null && company !== undefined && company.length !== 0) {
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [company]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={company} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose company type</option>
            {data.map((company) => ( 
                SetCompanyType(company)
            ))}
            </select>
        </div>
    );
};
function SetCompanyType(company){
    return(
        <option value={company.id}>{
            company.name}
        </option>
    )

}
function ClassificationIdSelect({classificationId, setClassificationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose classification</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
            </select>
        </div>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function DepartmentIdSelect({departmentId, setDepartmentId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setDepartmentId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Department/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(departmentId !== "" && departmentId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [departmentId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={departmentId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose department</option>
            {data.map((departmentId) => ( 
                SetDepartmentId(departmentId)
            ))}
            </select>
        </div>
    );
};
function SetDepartmentId(departmentId){
    return(
        <option value={departmentId.id}>{
            departmentId.description}
        </option>
    )
}
function LocationIdSelect({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose location</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}

export default Payslip
